
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
XButton
},
data() {
return {
selectTextItem: 'submit',
selectText: ''
}
},
methods: {
selectTextHandle() { //文本侯选点击
this.selectText = this.selectText + this.selectTextItem
},
}
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-select-text.vue